import { Box, Stack, Typography, Link } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { ForgotPasswordFormField } from '../components';
import { ForgotPasswordButton } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { useSendEmailForm, useSendEmailMutation } from '../hooks';

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const form = useSendEmailForm();
  const sendEmailMutation = useSendEmailMutation();

  const handleSubmit = form.handleSubmit((formData) => {
    sendEmailMutation.mutate(formData);
  });

  return (
    <FormProvider {...form}>
      <Stack
        component="form"
        width={'330px'}
        spacing={2}
        sx={{
          mt: 9,
        }}
        onSubmit={handleSubmit}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ color: '#33408e' }}
        >
          Forgot Password?
        </Typography>
        <Typography
          variant="body1"
          align="center"
          mb={3}
          sx={{ color: '#4c4c4c' }}
        >
          Enter your email and we'll send you <br/> a link to reset your password
        </Typography>

        <ForgotPasswordFormField />

        <Box display="flex" justifyContent="center">
          <ForgotPasswordButton type="submit" fullWidth disabled={sendEmailMutation.isPending}>
            {sendEmailMutation.isPending ? 'Sending...' : 'Send link to email'}
          </ForgotPasswordButton>
        </Box>

        <Box mt={3} mb={3} textAlign="center">
          <Link
            underline="hover"
            fontSize={13}
            sx={{ color: '#4c4c4c !important' }}
            onClick={() => navigate('/')}
          >
            Back to Login
          </Link>
        </Box>
      </Stack>
    </FormProvider>
  );
};
